module.exports = __webpack_public_path__ + "img/dj.2633b765.jpg";